import axios from 'axios'
import store from './../store';

export default class McbotService {




    async getAll() {

        const res = await axios({
            method: 'get',
            url: process.env.VUE_APP_AUTH_URL + 'api/v1/mcbot/all',
            headers: {
                authorization: store.state.currentUser.token
            }
        });
        //console.log(res.data);
        //console.log(res.data);
        return res.data;
    }

    async getAllSelf() {

        const res = await axios({
            method: 'get',
            url: process.env.VUE_APP_AUTH_URL + 'api/v1/mcbot/all/me',
            headers: {
                authorization: store.state.currentUser.token
            }
        });
        //console.log(res.data);
        //console.log(res.data);
        return res.data;
    }

    async chartDaySelf() {

        const res = await axios({
            method: 'get',
            url: process.env.VUE_APP_AUTH_URL + 'api/v1/mcbot/chart/day/me',
            headers: {
                authorization: store.state.currentUser.token
            }
        });
        //console.log(res.data);
        //console.log(res.data);
        return res.data;
    }

    async chartHourSelf() {

        const res = await axios({
            method: 'get',
            url: process.env.VUE_APP_AUTH_URL + 'api/v1/mcbot/chart/hour/me',
            headers: {
                authorization: store.state.currentUser.token
            }
        });
        //console.log(res.data);
        //console.log(res.data);
        return res.data;
    }


    async sumUSDSelf() {

        const res = await axios({
            method: 'get',
            url: process.env.VUE_APP_AUTH_URL + 'api/v1/mcbot/sum/usd/me',
            headers: {
                authorization: store.state.currentUser.token
            }
        });
        //console.log(res.data);
        //console.log(res.data);
        return res.data;
    }
    async sumXBTSelf() {

        const res = await axios({
            method: 'get',
            url: process.env.VUE_APP_AUTH_URL + 'api/v1/mcbot/sum/xbt/me',
            headers: {
                authorization: store.state.currentUser.token
            }
        });
        //console.log(res.data);
        //console.log(res.data);
        return res.data;
    }

    async sumUSD() {

        const res = await axios({
            method: 'get',
            url: process.env.VUE_APP_AUTH_URL + 'api/v1/mcbot/sum/usd',
            headers: {
                authorization: store.state.currentUser.token
            }
        });
        //console.log(res.data);
        //console.log(res.data);
        return res.data;
    }
    async sumXBT() {

        const res = await axios({
            method: 'get',
            url: process.env.VUE_APP_AUTH_URL + 'api/v1/mcbot/sum/xbt',
            headers: {
                authorization: store.state.currentUser.token
            }
        });
        //console.log(res.data);
        //console.log(res.data);
        return res.data;
    }

    async accountSummary() {

        const res = await axios({
            method: 'get',
            url: process.env.VUE_APP_AUTH_URL + 'api/v1/mcbot/accountsummary/me',
            headers: {
                authorization: store.state.currentUser.token
            }
        });
        //console.log(res.data);
        //console.log(res.data);
        return res.data;
    }

}